export default "__VITE_ASSET__BtjTH03w__"